import Order from 'app/components/orders/Order'
import ShowOrder from 'app/components/orders/ShowOrder'
import EditOrder from 'app/components/orders/EditOrder'
import TrackOrder from 'app/components/orders/TrackOrder'
import CableOnlyOrder from 'app/components/orders/CableOnlyOrder'

window.addEventListener('DOMContentLoaded', function () {
  window.waAdditionalComponents = {
    Order,
    ShowOrder,
    EditOrder,
    CableOnlyOrder,
    TrackOrder
  }
})
